import { useEffect, useMemo, useState } from 'react';
import { useMatches } from 'react-router-dom';

import { RadioContext } from './radioContext';
import RadioPlayer from './RadioPlayer';

export default function ArtGamesRadioProvider({ children }) {
  const matches = useMatches();
  const [snapshot, setSnapshot] = useState({ status: 'idle', trackId: null });
  const player = useMemo(() => new RadioPlayer(setSnapshot), []);
  const isRadioRoute = matches.some(match => match.handle?.artGamesRadio);

  useEffect(() => {
    if (isRadioRoute) player.activate();
    else player.deactivate();
  }, [isRadioRoute, player]);

  useEffect(() => () => player.deactivate(), [player]);

  const value = useMemo(() => ({
    ...snapshot,
    play: () => player.play(),
    pause: () => player.pause(),
    selectTrack: id => player.selectTrack(id),
  }), [player, snapshot]);

  return <RadioContext.Provider value={value}>{children}</RadioContext.Provider>;
}
